exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\r\n    width: 100%;\r\n    margin: auto;\r\n}\r\n\r\n@media (min-width: 480px) {\r\n    .container {\r\n        width: 80%;\r\n    }\r\n}\r\n\r\n@media (min-width: 1080px) {\r\n    .container {\r\n        width: 60%;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main